var _rect, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCwSimplifyYourDay(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 55,
    height: 55,
    viewBox: "0 0 55 55",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 55,
    height: 55,
    rx: 27.5,
    fill: "#6A097D"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.974,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M27.543 11.0913C28.2363 10.9401 28.7402 11.1745 29.0547 11.7945C29.1016 12.9195 29.1016 14.0445 29.0547 15.1695C28.6752 15.9132 28.101 16.1124 27.332 15.7671C27.1238 15.6063 26.9714 15.4071 26.875 15.1695C26.8281 14.0445 26.8281 12.9195 26.875 11.7945C27.0172 11.4767 27.2399 11.2423 27.543 11.0913Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.948,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.5734 15.661C16.9283 15.6348 17.2565 15.7168 17.5577 15.9071C18.2257 16.5751 18.8937 17.243 19.5617 17.911C19.9257 18.5042 19.867 19.055 19.3859 19.5634C18.8937 19.8915 18.4015 19.8915 17.9093 19.5634C17.2413 18.8954 16.5734 18.2274 15.9054 17.5595C15.4672 16.6821 15.6899 16.0493 16.5734 15.661Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.948,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M38.8626 15.6602C39.9894 15.6868 40.423 16.2493 40.1634 17.3477C39.4741 18.1073 38.7593 18.8456 38.0189 19.5625C37.2674 19.9835 36.6697 19.8312 36.2259 19.1055C36.0683 18.6851 36.1151 18.2867 36.3665 17.9102C37.0345 17.2422 37.7025 16.5742 38.3704 15.9062C38.526 15.7926 38.6901 15.7106 38.8626 15.6602Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.983,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M27.2612 18.2618C31.7458 18.2468 34.9685 20.2389 36.9292 24.2384C38.2808 27.9416 37.7183 31.3166 35.2417 34.3634C32.0001 37.6602 28.215 38.4688 23.8862 36.7891C20.9337 35.3292 19.1407 32.9737 18.5073 29.7227C17.8829 25.8307 19.0899 22.6549 22.1284 20.1954C23.68 19.1144 25.3909 18.4699 27.2612 18.2618ZM27.5425 20.5821C30.7936 20.6306 33.1726 22.0836 34.6792 24.9415C35.4001 26.5704 35.5055 28.2345 34.9956 29.9337C31.4613 30.6974 28.7074 29.5724 26.7339 26.5587C25.7085 24.7836 25.4624 22.9086 25.9956 20.9337C26.5078 20.7611 27.0234 20.644 27.5425 20.5821Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.974,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.7925 26.8396C12.9927 26.8075 14.188 26.8427 15.3784 26.9451C16.1284 27.6248 16.1284 28.3045 15.3784 28.9842C15.3081 29.0076 15.2378 29.0311 15.1675 29.0545C14.0425 29.1014 12.9175 29.1014 11.7925 29.0545C11.3012 28.8571 11.0669 28.4939 11.0894 27.9646C11.0755 27.4292 11.3098 27.0542 11.7925 26.8396Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.974,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M40.7625 26.8403C41.8877 26.8286 43.0127 26.8403 44.1375 26.8755C44.769 27.19 44.9917 27.6939 44.8054 28.3872C44.6766 28.7036 44.4539 28.9263 44.1375 29.0552C43.0125 29.1021 41.8875 29.1021 40.7625 29.0552C40.0179 28.673 39.8186 28.0987 40.1648 27.3325C40.3381 27.1229 40.5373 26.9589 40.7625 26.8403Z",
    fill: "white"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.948,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.4017 36.1211C19.5284 36.1477 19.962 36.7102 19.7025 37.8086C19.0132 38.5682 18.2983 39.3065 17.5579 40.0234C16.8064 40.4444 16.2087 40.2921 15.765 39.5664C15.6073 39.1461 15.6542 38.7476 15.9056 38.3711C16.5735 37.7031 17.2415 37.0352 17.9095 36.3672C18.0651 36.2536 18.2292 36.1715 18.4017 36.1211Z",
    fill: "white"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.948,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M37.0343 36.122C37.3893 36.0957 37.7174 36.1778 38.0187 36.368C38.6867 37.036 39.3546 37.704 40.0226 38.372C40.3866 38.9651 40.328 39.5159 39.8468 40.0243C39.3546 40.3524 38.8624 40.3524 38.3703 40.0243C37.7023 39.3563 37.0343 38.6884 36.3663 38.0204C35.9282 37.143 36.1508 36.5102 37.0343 36.122Z",
    fill: "white"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.974,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M27.6836 39.9866C28.3344 39.9075 28.7914 40.1653 29.0547 40.76C29.1016 41.885 29.1016 43.01 29.0547 44.135C28.7402 44.7665 28.2363 44.9892 27.543 44.803C27.2266 44.6741 27.0039 44.4514 26.875 44.135C26.8281 43.01 26.8281 41.885 26.875 40.76C27.0446 40.391 27.3142 40.1332 27.6836 39.9866Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCwSimplifyYourDay);
export default __webpack_public_path__ + "static/media/cw-simplify-your-day.ce0b6ce2446e91f432bc56e978ac4288.svg";
export { ForwardRef as ReactComponent };